const CategoryProductSang = [
    {
        ID: -1 , 
        ParentID: "",
        Name: "All Items",
    },
    {
        ID: 1001 , 
        ParentID: "",
        Name: "Travertine Stone",
    },
    {
        ID: 1002 , 
        ParentID: "",
        Name: "Marble Stone",
    },
    {
        ID: 1003 , 
        ParentID: "",
        Name: "Granite Stone",
    },
    {
        ID: 1004 , 
        ParentID: "",
        Name: "Onyx Stone",
    },
    // {
    //     ID: 1005 , 
    //     ParentID: "",
    //     Name: "Abbas Abad Stone",
    // },
    // {
    //     ID: 1006 , 
    //     ParentID: "",
    //     Name: "Lashtar Stone",
    // },
]
export default CategoryProductSang;
